import {
  EditContextProvider,
  Form,
  useEditController,
  useNotify,
  useRefresh,
  useTranslate,
} from 'react-admin';
import { Button as MUIButton, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { Resources } from '../../resource';
import CriticalHitTierForm from './CriticalHitTierForm';
import { CriticalHitTier, updateCriticalHitTier } from '../../../services/redpacketService';
import { useFormContext } from 'react-hook-form';
import { PermissionButton } from '../../../../../routes/components/permission-button';

const EditCriticalHitTier = ({
  id,
  onClose,
  record,
}: {
  id: string | number;
  onClose: () => void;
  record: CriticalHitTier;
}) => {
  const notify = useNotify();
  const t = useTranslate();
  const refresh = useRefresh();

  const controller = useEditController({
    id,
    resource: Resources.redpacket,
    mutationMode: 'pessimistic',
    mutationOptions: {
      onSuccess: () => {
        notify('update successful', { type: 'success' });
        refresh();
        onClose();
      },
      onError: (error: any) => {
        notify(error.message || 'update failed', { type: 'error' });
      },
    },
  });

  const CustomSaveButton = () => {
    const { handleSubmit } = useFormContext();
    const onSubmit = async (data: any) => {
      try {
        await updateCriticalHitTier({
          id: String(id),
          amount: data.amount ? String(data.amount) : undefined,
          probability: data.probability !== undefined ? Number(data.probability) : undefined,
          sortOrder: data.sortOrder ? Number(data.sortOrder) : undefined,
          isActive: data.isActive,
          description: data.description,
        });
        notify('update successful', { type: 'success' });
        refresh();
        onClose();
      } catch (error: any) {
        notify(error.message || 'update failed', { type: 'error' });
      }
    };
    return <MUIButton onClick={handleSubmit(onSubmit)}>Save</MUIButton>;
  };

  if (controller.isLoading || !controller.record) return null;

  return (
    <EditContextProvider value={controller}>
      <Form disableInvalidFormNotification defaultValues={controller.record}>
        <DialogTitle>edit critical hit amount weight configuration</DialogTitle>
        <DialogContent>
          <CriticalHitTierForm isCreate={false} record={record} />
        </DialogContent>
        <DialogActions>
          <MUIButton variant="outlined" onClick={onClose}>
            {t('actions.cancel')}
          </MUIButton>
          <PermissionButton resource="redpacket" action="update">
            <CustomSaveButton />
          </PermissionButton>
        </DialogActions>
      </Form>
    </EditContextProvider>
  );
};

export default EditCriticalHitTier;
